(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate','$state'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate,$state) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                email: account.email,
                lastName: account.lastName,
                login: account.login,
                nasracAdminCustomerAccountFirstName: account.nasracAdminCustomerAccountFirstName,
                displayName: account.displayName,
                firstName:account.firstName,
                userFirstName:account.firstName
            };
        };

        Principal.identity().then(function(account) {
           // vm.settingsAccount=account;
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                   // vm.settingsAccount=account;
                    vm.settingsAccount = copyAccount(account);
                    gotoHome();
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });

            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }


        function gotoHome() {

            var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result) {
                vm.isAdmin = result;
                if (vm.isAdmin === true && Principal.isAuthenticated()) {
                    $state.go('home-main.home-page', {}, {
                        reload: true
                    });
                }
                else if (vm.isAdmin === false && Principal.isAuthenticated()) {
                    $state.go('user-home-page', {}, {
                        reload: true
                    });
                }
            });
        }
    }
})();
